interface EnvConfig {
  API_URL: string;
  // OAuth Web client ID for Google sign-in; empty hides the Google button
  GOOGLE_CLIENT_ID: string;
}

const createConfig = (): EnvConfig => {
  return {
    API_URL: process.env.REACT_APP_API_URL || '/api',
    GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  };
};

const config = createConfig();

export default config;